/* eslint no-param-reassign: "off" */

import ElementUpdater from './elementUpdater'
import Selector from './selector'

const updateWeekView = (styles) => {
  const {
    backgroundColor,
    secondaryBackgroundColor,
    titleFontColor,
    cardBoxShadow,
  } = styles

  const weekViewBackgroundImageSelector =
    '.presentation_slide.week_view_slide .slide_background_image_wrapper'
  const slideContentsSelector =
    '.presentation_slide.week_view_slide .slide_contents'
  const timeLabelWrapperSelector =
    '.presentation_slide.week_view_slide .ts_segment_label_wrapper'
  const dayLabelsSelector =
    '.presentation_slide.week_view_slide .timeslicer .bucket_title'
  const momentCountSelector =
    '.presentation_slide.week_view_slide .timeslicer .bucket_count'
  const timeLabelSelector = '.timeslicer .ts_segment_label .ts_label'
  const dayLabelBorderSelector =
    '.presentation_slide.week_view_slide .timeslicer .ts_day_labels'
  const noMomentsSelector =
    '.presentation_slide.week_view_slide .ts_segment_empty'
  const headerSelector = '.presentation_slide.week_view_slide .header'
  const timeslicerRegion =
    '.presentation_slide.week_view_slide .timeslicer_region'
  const tsStreamSegments =
    '.presentation_slide.week_view_slide .ts_stream_segments'
  const descriptionSelector =
    '.presentation_slide.week_view_slide .slide_description'
  const momentCard = '.presentation_slide.week_view_slide .momentCard'

  const fiftyPercentAlpha = '7C'
  const transparentBackgroundColor =
    secondaryBackgroundColor + fiftyPercentAlpha

  const selectors = [
    new Selector({
      selection: weekViewBackgroundImageSelector,
      required: true,
    }),
    new Selector({
      selection: slideContentsSelector,
      required: true,
    }),
    new Selector({
      selection: timeLabelWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: dayLabelsSelector,
      required: true,
    }),
    new Selector({
      selection: momentCountSelector,
      required: true,
    }),
    new Selector({
      selection: timeLabelSelector,
      required: true,
    }),
    new Selector({
      selection: dayLabelBorderSelector,
      required: true,
    }),
    new Selector({
      selection: noMomentsSelector,
      required: true,
    }),
    new Selector({
      selection: headerSelector,
      required: true,
    }),
    new Selector({
      selection: timeslicerRegion,
      required: true,
    }),
    new Selector({
      selection: tsStreamSegments,
      required: true,
    }),
    new Selector({
      selection: momentCard,
      required: true,
    }),
    new Selector({
      selection: descriptionSelector,
      required: true,
    }),
  ]

  const updateStyles = () => {
    document
      .querySelectorAll(weekViewBackgroundImageSelector)
      .forEach((element) => {
        element.style.top = '0'
      })

    document.querySelectorAll(slideContentsSelector).forEach((element) => {
      element.style['background-color'] = backgroundColor
      element.style.top = '80px'
    })

    document.querySelectorAll(timeLabelWrapperSelector).forEach((element) => {
      element.style['background-color'] = transparentBackgroundColor
    })

    document.querySelectorAll(dayLabelsSelector).forEach((element) => {
      element.style.color = titleFontColor
    })
    document.querySelectorAll(momentCountSelector).forEach((element) => {
      element.style.color = titleFontColor
      element.style.opacity = '0.7'
    })

    document.querySelectorAll(timeLabelSelector).forEach((element) => {
      element.style.color = titleFontColor
    })

    document.querySelectorAll(dayLabelBorderSelector).forEach((element) => {
      element.style['border-color'] = secondaryBackgroundColor
    })

    document.querySelectorAll(noMomentsSelector).forEach((element) => {
      element.style['border-color'] = transparentBackgroundColor
      element.style.color = transparentBackgroundColor
    })

    document.querySelectorAll(headerSelector).forEach((element) => {
      element.style.height = 'auto'
    })

    document.querySelectorAll(timeslicerRegion).forEach((element) => {
      element.style.position = 'static'
    })

    let hasHeader = 0
    if (document.querySelectorAll('.kuiper-presentations-header'))
      hasHeader = 80

    document.querySelectorAll(tsStreamSegments).forEach((element) => {
      element.style.top = `calc(144px + ${hasHeader}px`
    })

    document.querySelectorAll(descriptionSelector).forEach((element) => {
      if (element.innerHTML === '') {
        element.style.display = 'none'
      }
    })

    document.querySelectorAll(momentCard).forEach((element) => {
      element.style['box-shadow'] = cardBoxShadow
    })
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateWeekView
